import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';

const AdminLayout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const getTitle = () => {
    const path = window.location.pathname;
    const titles = {
      '/admin/dashboard': 'Dashboard',
      '/admin/portfolio': 'Portfolio Management',
      '/admin/contact-settings': 'Contact Settings',
      '/admin/website-content': 'Website Content',
      '/admin/leads': 'Contact Form Leads',
      '/admin/media': 'Media Manager',
      '/admin/settings': 'Settings',
    };
    return titles[path] || 'Admin Panel';
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />
      <div className={`transition-all duration-300 ${sidebarCollapsed ? 'lg:ml-16' : 'lg:ml-64'}`}>
        <Navbar title={getTitle()} onMenuClick={() => setMobileOpen(true)} />
        <main className="p-4 lg:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
